import { render, staticRenderFns } from "./manageAttachmentsTable.vue?vue&type=template&id=8238563e"
import script from "./manageAttachmentsTable.ts?vue&type=script&lang=js&external"
export * from "./manageAttachmentsTable.ts?vue&type=script&lang=js&external"
import style0 from "./manageAttachmentsTable.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports